<template>
  <div
    :class="['page-header', is_maintenance_cycle ? 'p-fixed' : '']"
    v-if="show"
  >
    <div class="left">
      <img class="app-icon" v-if="app_icon" :src="app_icon" alt="" />
      <img
        class="app-icon"
        v-else
        src="@/assets/maintain/shell_logo.png"
        alt=""
      />
      <div class="app-name">{{ app_name }}</div>
    </div>
    <div class="right" @click="toFeedback">
      <img
        class="feedback-icon"
        src="@/assets/home/black-feedback-icon.png"
        alt=""
      />
      <div class="feedback-text">反馈</div>
    </div>
  </div>
</template>

<script>
import MaintenanceApi from "@/apis/maintenance-api.js";
export default {
  name: "PageHeader",
  data() {
    return {
      is_maintenance_cycle: true,
      show: false,
      app_icon: "",
      app_name: "精养服务助手",
      no_use_pages: [
        "Home",
        "gearbox-oil-poster",
        "insurance-introduction",
        "insurance-poster",
        "love-value-mall-poster",
        "store-list",
      ],
    };
  },
  watch: {
    $route(value) {
      if (this.no_use_pages.includes(value.name)) {
        this.show = false;
      } else {
        this.show = true;
      }
      if (
        value.name === "maintenance-cycle" ||
        value.name === "maintenance-detail"
      ) {
        this.is_maintenance_cycle = true;
      } else {
        this.is_maintenance_cycle = false;
      }
      if (value.query.scheme_id || value.query.id) {
        this.initData();
      }

      // 抖音小程序过来的，不展示头部
      let from = window.sessionStorage.getItem("FROM");
      if (from == "tt-oil") {
        this.show = false;
      }
    },
  },
  mounted() {},

  updated() {},
  destroyed() {},
  methods: {
    // 去反馈
    toFeedback() {
      this.$router.push({
        path: "/maintenance-feedback",
      });
    },
    async initData() {
      if (
        !sessionStorage.getItem("OILSHARE") &&
        (this.$route.query.scheme_id || this.$route.query.id)
      ) {
        const res = await MaintenanceApi.getShareApi({
          scheme_id: this.$route.query.scheme_id || this.$route.query.id,
        });
        if (res.code === 0) {
          sessionStorage.setItem("OILSHARE", JSON.stringify(res.data));
          this.app_icon = res.data.h5_logo;
          this.app_name = res.data.name;
        } else {
          console.error("数据统计失败", res.message);
        }
      } else if (sessionStorage.getItem("OILSHARE")) {
        const obj = JSON.parse(sessionStorage.getItem("OILSHARE"));
        this.app_icon = obj.h5_logo;
        this.app_name = obj.name;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.p-fixed {
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 11;
}
.page-header {
  height: 106/100rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: url(../assets/home/header-bg.png) no-repeat;
  background-size: 100% 100%;
  .left {
    display: flex;
    padding-left: 20/100rem;
    .app-icon {
      width: 41/100rem;
      height: 41/100rem;
      flex-shrink: 0;
      margin: 0 14/100rem 0 8/100rem;
      // background: pink;
    }
    .app-name {
      font-weight: bold;
      color: #000000;
      font-size: 27/100rem;
    }
  }
  .right {
    height: 100%;
    width: 78/100rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    img {
      width: 38/100rem;
      height: 32/100rem;
      margin-bottom: 5/100rem;
      margin-top: 5/100rem;
    }
    .feedback-text {
      font-weight: 500;
      color: #333333;
      line-height: 29/100rem;
      font-size: 20/100rem;
      margin-top: 5/100rem;
    }
  }
}
</style>
